import RisingFastDetail from "@/Component/Brand/BrowseInfluencer/BrowseInfluencerDetail/RisingFastDetail"

const RisingFastDetailPage = () => {
  return (
    <RisingFastDetail />
  )
}

export default RisingFastDetailPage
